import axios from "axios";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
import cookie from "js-cookie";
import vailcode from "@utils/errcode";
export default {
  name: "popTask",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "setting"])
  },
  data() {
    return {
      modifyData: {},
      isUploading: false,
      isSubmit: false,
      showOptions: false,
      gift_list: [],
      gift_extra: null
    };
  },
  watch: {
    "$parent.popGitfShow": {
      async handler(newVal, oldVal) {
        if (newVal) {
          this.showOptions = false;
          this.gift_extra = null;
          this.gift_list = [];
          this.modifyData = Object.assign({}, this.$parent.modifyData);
          if (this.modifyData.gift_type == 1) {
            let rs = await this.$http.post("/lucky/gift/business", {});
            this.gift_list = rs.data;
          }
        } else {
          this.isSubmit = false;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async onConfirm() {
      if (this.isSubmit) return false;
      this.isSubmit = true;
      let rs = await this.$http.post("/lucky/gift/order/send", this.modifyData);
      this.isSubmit = false;
      vailcode(rs, () => {
        this.$parent.getData();
        this.$parent.popGitfShow = false;
      });
    }
  }
};